import { render, staticRenderFns } from "./TreatmentDetail.vue?vue&type=template&id=7b331996&scoped=true"
var script = {}
import style0 from "./TreatmentDetail.vue?vue&type=style&index=0&id=7b331996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b331996",
  null
  
)

export default component.exports